import { useCallback, useEffect, useState } from 'react';

import { LayoutVariableDefinition } from 'dashboard/models/layout-variable-definitions';
import { JsonSchemaBase, JsonSchemaObject, JsonSchemaTypes } from 'lib/json-schema';

export const useDataContextSchema = (
  variableDefinitions: LayoutVariableDefinition[],
  getObjectSchema: (ref: string) => Promise<JsonSchemaBase | null | undefined>,
) => {
  const [dataSchema, setDataSchema] = useState<JsonSchemaObject>({
    type: JsonSchemaTypes.Object,
    properties: {},
  });

  const getLayoutVariableSchemas = useCallback(async () => {
    const variableSchemas: JsonSchemaObject = {
      type: JsonSchemaTypes.Object,
      properties: {},
    };

    for (const definition of variableDefinitions) {
      const ref = definition.json_schema.$ref;

      if (ref != null) {
        const schema = await getObjectSchema(ref);

        if (schema == null) continue;

        variableSchemas.properties[definition.key] = schema;
        continue;
      }

      variableSchemas.properties[definition.key] = definition['json_schema'];
    }

    setDataSchema(variableSchemas);
  }, [variableDefinitions, getObjectSchema]);

  useEffect(() => {
    getLayoutVariableSchemas();
  }, [variableDefinitions, getLayoutVariableSchemas]);

  return { dataSchema };
};
